const getPenaltiesWidgets = (ctx) => {
  return {
    name: '',
    widgets: [
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('penaltyCount'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'numberOfPenalties',
        data: null
      },
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('penaltiesSum'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'sumOfPenalties',
        data: null
      }
    ]
  }
}

export default getPenaltiesWidgets